import { Component, ChangeDetectionStrategy, inject, OnInit, OnDestroy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from '../../../shared/components/wl_components/button/button.component';
import { Button } from '../../../shared/models/wl_components/button.interface';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'sjp-log-out-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ButtonComponent, MatIconModule],
  templateUrl: './log-out-modal.component.html',
  styleUrl: './log-out-modal.component.scss',
})
export class LogOutModalComponent implements OnInit, OnDestroy {
  private _dialogRef = inject(MatDialogRef<LogOutModalComponent>);
  private _countdownTimer: any;
  
  // Gets timeout from environment (defaulting to 60s if not provided)
  public secondsRemaining = signal<number>((environment as any).sessionModalTimeoutSeconds || 60);

  cancelBtnConfig: Button = {
    text: $localize`:@@logout.modal.cancel:Cancel`,
    type: 'secondary'
  };

  confirmBtnConfig: Button = {
    text: $localize`:@@logout.modal.confirm:Confirm`,
    type: 'primary'
  };

  ngOnInit() {
    this._startCountdown();
  }

  ngOnDestroy() {
    this._clearCountdown();
  }

  private _startCountdown() {
    this._countdownTimer = setInterval(() => {
      this.secondsRemaining.update(sec => sec - 1);
      if (this.secondsRemaining() <= 0) {
        this.onConfirm();
      }
    }, 1000);
  }

  private _clearCountdown() {
    if (this._countdownTimer) {
      clearInterval(this._countdownTimer);
    }
  }

  onCancel() {
    this._clearCountdown();
    this._dialogRef.close(false);
  }

  onConfirm() {
    this._clearCountdown();
    this._dialogRef.close(true);
  }
}
